import { useEffect, useState } from 'react';
import type React from 'react';
import { logError } from '../../../../utils/logger';

export const useLazyMapBBoxSelector = (): React.ComponentType | null => {
  const [MapBBoxSelector, setMapBBoxSelector] =
    useState<React.ComponentType | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      import('../components/MapBBoxSelector/MapBBoxSelector')
        .then((module) => setMapBBoxSelector(() => module.default))
        .catch((error) => logError('Failed to load MapBBoxSelector:', error));
    }
  }, []);

  return MapBBoxSelector;
};
